import { createIcons, icons } from "lucide";

export class Icons {
  constructor() {
    this.init();
  }
  init() {
   createIcons({ icons });
  }
}

